import React from "react";
import ScrollBars from "./customScrollbar";

const renderTrackVertical = ({ style, ...props }) => {
  const viewStyle = {
    right: 0,
    bottom: "0",
    top: "0",
    width: "1rem",
    borderLeft: "1px solid rgba(94,129,209,0.32)"
  };
  return <div style={{ ...style, ...viewStyle }} {...props} />;
};
const renderThumbVertical = ({ style, ...props }) => {
  const viewStyle = {
    cursor: "pointer",
    backgroundColor: "#084D81",
    opacity: 0.5
  };
  return <div style={{ ...style, ...viewStyle }} {...props} />;
};

// Something interesting to remember
// The scrollbars are always visible, they are just hidden from view
// The View div has some negative margin
// that's how it hides the scroll bar
export const ScrollBar = React.forwardRef((props, ref) => {
  return (
    <ScrollBars
      ref={ref}
      {...props}
      renderThumbVertical={renderThumbVertical}
      renderTrackVertical={renderTrackVertical}
      style={{ flexGrow: 1 }}
    />
  );
});
